import { FormSectionHandler } from '../entity.handler';
import { FuelCardResponse, FuelCardUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils } from '../utils';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    brandName?: string;
    embossedName?: string;
    expiryDate?: string;
    description?: string;
}

export class FuelCardDetailsSectionHandler implements FormSectionHandler<FuelCardResponse, EditorValues> {

    type = 'form';
    icon = ICONS.fuelcard;
    bulk = true;
    
    title = this.translate('TITLE'); 
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    private properties = ['name', 'brandName', 'embossedName', 'expiryDate', 'description'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.FUELCARD.DETAILS.${key}`, values);
    }

    applyUpdate(entity: FuelCardResponse, payload: FuelCardUpdateRequest): Promise<FuelCardResponse> {
        return this.admin.applyUpdate(api => api.entities.updateFuelCard(entity.id, payload));
    }

    mapEntityToEditor(entity: FuelCardResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: FuelCardUpdateRequest, values: EditorValues): Promise<FuelCardUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    getFields(entity: FuelCardResponse): Promise<FormBuilderField[]> {
        return Promise.resolve().then(() => {
            return [
                TextField('name', this.translate('FIELDS.SERIAL_NUMBER'), true, 1, 255),
                TextField('brandName', this.translate('FIELDS.BRAND_NAME'), true, 1, 255),
                TextField('embossedName', this.translate('FIELDS.EMBOSSED_NAME'), true, 1, 255),
                TextField('expiryDate', this.translate('FIELDS.EXPIRY_DATE'), true, 1, 255),
                TextField('description', this.translate('FIELDS.DESCRIPTION'), false, 1, 1024),
            ];
        }).then(fields => EntityUtils.prepareBulk(!entity, ['brandName', 'embossedName', 'description', 'expiryDate'], fields));
    }

}
